import createSvgIcon from "./utils/create_icon"

const InfoFill = createSvgIcon(<path clipRule="evenodd" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM11 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm0 3a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0z" fill="currentColor" fillRule="evenodd" />, "InfoFill")
export default InfoFill
